import qs from 'qs'
import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { filterShallowObject } from 'Services/extraObject'
import { apiUrl } from 'Services/accessUrl'

const endpoint = `${apiUrl.stable}/empresa`

// #region Signup
/**
 * Signup a user with associated to company
 * @param {ApiSignupCompany} data
 */
export const signupCompany = (data, isLogged) => {
  if (isLogged) {
    const headers = { ...jsonWebToken.header }
    const url = `${endpoint}/anuncie`

    return axios.post(url, data, { headers })
  } else {
    const url = `${endpoint}/anuncie`

    return axios.post(url, data)
  }

}

// #endregion

// #region Profile
/**
 * @param {string} slug
 * @returns {Promise.<{ data: ApiCompanyProfile }>}
 */
export const getProfile = (slug) => {
  const url = `${endpoint}/${slug}`

  return axios.get(url)
}

/**
 * @param {number} companyId
 * @returns {Promise.<{ data: ApiCompanyProfileReview[] }>}
 */
export const getReviews = (companyId) => {
  const url = `${endpoint}/avaliacoes/${companyId}`

  return axios.get(url)
}

/**
 * @param {number} idCompany
 * @returns {Promise.<{ data: ApiServiceTypeEdit[] }>}
 */
export const getCompanyServices = (idCompany) => {
  const url = `${apiUrl.stable}/categoria/especialidade/company`

  const params = { idCompany }

  return axios.get(url, { params })
}
// #endregion

// #region Account

/** * @returns {Promise.<{ data: ApiCompanyAccount }>} */
export const getCompanyInfo = () => {
  const url = `${endpoint}/obtem`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getCompanyPhone = () => {
  const url = `${endpoint}/obtem/telefone`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

/** * @param {ApiCompanyAccountEdit} data */
export const editCompanyInfo = (data) => {
  const url = `${endpoint}/atualiza`

  const headers = { ...jsonWebToken.header }

  return axios.put(url, data, { headers })
}

/**
 * @param path {string}
 */
export const uploadLogo = (path)  => {
  const url = `${endpoint}/upload/logo`

  const params = qs.stringify({
    Path: path
  })

  const headers = { ...jsonWebToken.header }

  return axios.post(url, params, { headers })
}

/**
 * @returns {Promise.<{ data: ApiCompanyAccountPhoto[] }>}
 */
export const getPhotos = () => {
  const url = `${endpoint}/photogallery/list`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

/**
 * @param path {string}
 * @param description {string}
 */
export const uploadPhoto = (path, description = '') => {
  const url = `${endpoint}/photogallery/upload`

  const params = qs.stringify({
    Path: path,
    Caption: description
  })

  const headers = { ...jsonWebToken.header }

  return axios.post(url, params, { headers })
}

/**
 * @param id {number}
 */
export const deletePhoto = (id) => {
  const url = `${endpoint}/photogallery/delete`

  const params = { id }

  const headers = { ...jsonWebToken.header }

  return axios.delete(url, { headers, params })
}
// #endregion

// #region Services
/**
 * @param {number[]} servicesIdList
 */
export const submitServices = (servicesIdList) => {
  const url = `${endpoint}/tiposervico/associar`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }

  return axios.post(url, servicesIdList, axiosConfig)
}

/**
 * @param {number[]} stateIdList
 */
export const submitStates = (stateIdList) => {
  const url = `${endpoint}/estado/associar`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }

  return axios.post(url, stateIdList, axiosConfig)
}

/**
 * @param {number[]} cityIdList
 */
export const submitCities = (cityIdList) => {
  const url = `${endpoint}/cidade/associar`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }

  return axios.post(url, cityIdList, axiosConfig)
}

/**
 * @param {number[]} zoneIdList
 */
export const submitZones = (zoneIdList) => {
  const url = `${endpoint}/zona/associar`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }

  return axios.post(url, zoneIdList, axiosConfig)
}
// #endregion

// #region Coverage
export const getCategoryAssociation = () => {
  const url = `${endpoint}/tiposervico/listar`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }
  return axios.get(url, axiosConfig)
}

/**
 * @returns {Promise.<{ data: ApiCompanyRegion[] }>}
 */
export const getAssociatedCities = () => {
  const url = `${endpoint}/cidade/listar`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }
  return axios.get(url, axiosConfig)

}

/**
 * @returns {Promise.<{ data: SmartServiceTypeResult[] }>}
 */
export const getSmartCategorization = () => {
  const url = `${endpoint}/tiposervico/categorizacao-inteligente`

  const axiosConfig = {
    headers: { ...jsonWebToken.header },
    timeout: 20000
  }
  return axios.get(url, axiosConfig)
}
// #endregion

// #region Buildings
/**
 * Add a new address to the user's company account
 * @param {number} page
 * @param {object} [options]
 * @param {string} [options.filter]
 * @param {number} [options.pageSize]
 * @param {boolean} [options.alphabeticalOrder]
 * @returns {Promise.<{ data: ApiAddressList }>} data
 */
export const getBuildingList = (page = 1, options = {}) => {
  const url = `${endpoint}/endereco/lista`

  const queries = {
    Page: page,
    PageSize: options.pageSize || null,
    Filter: options.filter || null,
    AlphabeticalOrder: typeof options.alphabeticalOrder !== 'undefined'
      ? options.alphabeticalOrder
      : null
  }

  const params = filterShallowObject(queries, item => item !== null)

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers, params })
}

/**
 * Add a new address to the user's company account
 * @param {number} addressId
 * @returns {Promise.<{ data: ApiAddressDetails }>} data
 */
export const getCompanyBuildingDetails = (addressId) => {
  const url = `${endpoint}/endereco/detalhe`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    id: addressId
  }

  return axios.get(url, { headers, params })
}

/**
 * Add a new address to the user's company account
 * @param {ApiAddressCreate} data
 */
export const addBuilding = (data) => {
  const url = `${endpoint}/endereco/adiciona`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.post(url, data, { headers })
}

/**
 * Add a new address to the user's company account
 * @param {ApiAddressUpdate} data
 */
export const updateBuilding = (data) => {
  const url = `${endpoint}/endereco/altera`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.put(url, data, { headers })
}

/**
 * Add a new address to the user's company account
 * @param {number} addressId
 */
export const removeBuilding = (addressId) => {
  const url = `${endpoint}/endereco/remove`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    id: addressId
  }

  return axios.delete(url, { headers, params })
}
// #endregion

// #region Users
/**
 * @param {number} [page=1]
 * @param {object} [options]
 * @param {number} [options.pageSize]
 * @returns {Promise.<{ data: ApiCompanyUserResult }>}
 */
export const getUserList = (page = 1, options = {}) => {
  const url = `${endpoint}/user/lista`

  const { pageSize = 10 } = options

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    Page: page,
    PageSize: pageSize,
  }

  return axios.get(url, { headers, params })
}

/**
 * @param {ApiCompanyUserCreate} data
 */
export const addUser = (data) => {
  const url = `${endpoint}/user/convidar`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.post(url, data, { headers })
}

/**
 * @param {number} userId
 */
export const removeUser = (email) => {
  const url = `${endpoint}/user/desassociar`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    email: email
  }

  return axios.put(url, null, { headers, params })
}

export const updateUserRole = (email, role) => {
  const url = `${endpoint}/user/atualizar-role`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    email: email,
    role: role
  }

  return axios.put(url, null, { headers, params })
}

// #endregion

export const getAccountStatus = () => {

  const url = `${endpoint}/status`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }
  return axios.get(url, axiosConfig)
}

// #region Automatic Message

/**
 * Obtém a mensagem automática da empresa logada
 * @returns {Promise<{ data: ApiCompanyAutomaticMessageResponse }>}
 */
export const getCompanyAutomaticMessage = () => {
  const url = `${endpoint}/mensagem-automatica`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

/**
 * Cadastra ou atualiza a mensagem automática da empresa logada
 * @param {ApiCompanyAutomaticMessageRequest} data
 * @returns {Promise<{ data: ApiCompanyAutomaticMessageResponse }>}
 */
export const upsertCompanyAutomaticMessage = (data) => {
  const url = `${endpoint}/mensagem-automatica`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.post(url, data, { headers })
}

// #endregion

export default {
  addBuilding,
  editCompanyInfo,
  getAssociatedCities,
  getBuildingList,
  getCategoryAssociation,
  getCompanyBuildingDetails,
  getCompanyInfo,
  getSmartCategorization,
  removeBuilding,
  signupCompany,
  submitCities,
  submitServices,
  submitStates,
  submitZones,
  updateBuilding,
  uploadLogo,
  getAccountStatus,
  getCompanyAutomaticMessage,
  upsertCompanyAutomaticMessage
}
